const getIntersectionObserverCb = (handleSetInViewport) => (entries) => handleSetInViewport(entries[0].isIntersecting);
export default getIntersectionObserverCb;
//# sourceMappingURL=getIntersectionObserverCb.js.map